import styled from "@emotion/styled";

export const DatePickerDialogMonthContainer = styled("div")`
    display: flex;
    justify-content: space-between;
    align-items: center;

    height: 28px;
`;
